import creditCardIcon from './CreditCardIcon';

export default creditCardIcon;
